
import axios from "../axios";
import { DISPLAY_LANG } from "../config";


export const helpingCenterPageHeading = async ()=>{
  const response = await axios.get(`global/help_center_page_heading`);
  return response.data;
}

export const helpingCenterPage = async () => {
  const response = await axios.get(`global/help-center?lang=${DISPLAY_LANG}`);
   return response.data;
};


export const helpingCenterDetailsPage = async (id) => {
  const response = await axios.get(`global/help-center?id=${id}`);
  return response.data;
};
